import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Skeleton from "@material-ui/lab/Skeleton";
import { withStyles } from "@material-ui/styles";
const styles = (theme) => {
  return {
    root: {
      //  "& .MuiCircularProgress-colorPrimary": {
      //     color:color.WHITE
      // }
    }
  }
}
class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    try {
      if (this.props.type == "loader") {

        return (
          <div
          //   className="Loader"
          >
            <CircularProgress
              size={this.props.size == undefined ? 40 : this.props.size}
              className={this.props.className}
              thickness={this.props.thickness != undefined ? this.props.thickness : 2}
              style={{ color: this.props.color }}
            />
          </div>
        );
      } else {
        return (

          <Skeleton style={this.props.style != undefined ? this.props.style : {
            width: "100%",
            height: 31,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            margin: 2.225

          }}
          >
          </Skeleton>
        )
      }
    } catch (err) {
      console.log(err)
    }
  }
}
export default withStyles(styles)(Loader);